/**
 * Small stat tile. `value` may be "غير متاح" for unavailable metrics —
 * NEVER pass 0 in that case (product rule: don't fake zeros for missing data).
 */
export default function StatCard({ testid, label, value, hint, tone = "slate" }) {
  const toneClass =
    tone === "emerald"
      ? "bg-emerald-50 border-emerald-200"
      : tone === "amber"
      ? "bg-amber-50 border-amber-200"
      : tone === "red"
      ? "bg-red-50 border-red-200"
      : "bg-white border-slate-200";
  return (
    <div
      data-testid={testid}
      className={`${toneClass} border-2 rounded-2xl px-4 py-3`}
    >
      <div className="text-xs font-bold text-slate-500 mb-1">{label}</div>
      <div className="text-2xl font-bold text-slate-900" dir="ltr">
        {value}
      </div>
      {hint && <div className="text-xs text-slate-500 mt-1">{hint}</div>}
    </div>
  );
}
